import React, { Component } from "react";
import Slider from "react-slick";
import { BenifitItem } from "../soundboxwork";
import instant from "../../assets/svgs/instant.svg";
import languge from "../../assets/svgs/language.svg";
import accept from "../../assets/svgs/accpects.svg";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useWindowSize } from "@uidotdev/usehooks";
import PropTypes from "prop-types";

export const SliderMulipItems = () => {
  const { width } = useWindowSize();
  let isswipe;
  let show;
  let isInfinite;

  if (width > 1023) {
    isswipe = 3;
    show = false;
  } else if (width < 1024 && width > 871) {
    isswipe = 2;
    show = true;
  } else {
    isswipe = 1;
    show = true;
  }

  const { t } = useTranslation();
  const settings = {
    dots: show,
    arrows: false, // Ẩn các mũi tên điều hướng
    infinite: false,
    speed: 500,
    slidesToShow: isswipe,
    slidesToScroll: 1,
  };
  return (
    <div className="slider-container ml-[30px] mt-[20px] sm:ml-0">
      <Slider {...settings}>
        <BenifitItem
          image={instant}
          titleheader={t("homepage.uinstant")}
          title={t("homepage.uinstantdes")}
        />
        <BenifitItem
          image={languge}
          titleheader={t("homepage.language")}
          title={t("homepage.languagedes")}
        />
        <BenifitItem
          image={accept}
          titleheader={t("homepage.accepts")}
          title={t("homepage.acceptsdes")}
        />
      </Slider>
    </div>
  );
};
SliderMulipItems.propTypes = {
  isCheck: PropTypes.bool,
};
